export function injectGtm (id: string): void {
  // Inject GTM <script> tag into head
  const gtmScript = document.createElement('script')
  const insightsUri = import.meta.env.VUE_APP_INSIGHTS_URI || 'https://insights.serato.net'
  const gtmParams = import.meta.env.VUE_APP_GTM_PARAMS || ''
  gtmScript.async = true
  gtmScript.src = `${insightsUri}/gtm.js?id=${id}${gtmParams}`
  document.head.append(gtmScript)
}
